var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1757471711036,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 18497,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M950.857143 548.571429c-54.272-84.004571-128.585143-156.013714-217.709714-201.728A253.915429 253.915429 0 0 1 768 475.428571c0 141.129143-114.870857 256-256 256s-256-114.870857-256-256c0-45.129143 11.995429-89.709714 34.852571-128.585142C201.691429 392.557714 127.414857 464.566857 73.142857 548.571429c97.718857 150.857143 255.414857 256 438.857143 256s341.138286-105.142857 438.857143-256zM539.428571 329.142857a27.794286 27.794286 0 0 0-27.428571-27.428571c-95.414857 0-173.714286 78.299429-173.714286 173.714285 0 14.848 12.580571 27.428571 27.428572 27.428572s27.428571-12.580571 27.428571-27.428572A119.515429 119.515429 0 0 1 512 356.571429a27.794286 27.794286 0 0 0 27.428571-27.428572zM1024 548.571429c0 14.299429-4.571429 27.428571-11.446857 39.424C907.410286 761.124571 714.825143 877.714286 512 877.714286S116.553143 760.576 11.446857 587.995429C4.608 576 0 562.834286 0 548.571429s4.571429-27.428571 11.446857-39.424C116.589714 336.566857 309.174857 219.428571 512 219.428571s395.446857 117.138286 500.553143 289.718858c6.838857 11.995429 11.446857 25.161143 11.446857 39.424z",
    "p-id": 18498
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f61a6a57.svg";
export { ForwardRef as ReactComponent };